import { useFeature } from "@/hooks/useFeatures";

/**
 * The single gate for bulk link editing. `enabled` is the rollout flag AND at
 * least one link section being available: one Apply can write to Tekmetric for
 * many containers, so the flag decides whether the dialog can open at all,
 * while the two existing link flags decide which sections it shows. Entry
 * points (WEBV3-337 list view, WEBV3-342 canvas) use this to hide their
 * buttons so the rule lives in one place.
 */
export const useBulkLinkEditAvailability = () => {
  const rolloutEnabled = useFeature("isBulkLinkEditEnabled");
  const showTechnicians = useFeature("isTechnicianLinkEnabled");
  const showLabels = useFeature("isROLabelLinkEnabled");

  return {
    enabled: rolloutEnabled && (showTechnicians || showLabels),
    showTechnicians,
    showLabels,
  };
};
